module.exports = __webpack_public_path__ + "fa-light-300.svg?7fc88777fc3ee282f4bda2ff4a6fff9a";